import React, { useEffect, useRef, useState } from "react";
import FooterFixed from "./FooterFixed";
import { ReactComponent as AuthenticationIcon } from "../assets/images/icons/AuthenticationIcon.svg";
import Button from "./UniversalComponents/DefaultButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { VERIFY_OTP, VERIFY_RESET_OTP } from "../utils/constants";
import ZinancialLogo from "../assets/images/ZinancialLogo.webp";
import { ReactComponent as LeftSideArrowIcon } from "../assets/images/icons/LeftSideArrowIcon.svg";

const AuthenticationBox = () => {
  const [email, setEmail] = useState("abc@gmail.com");
  const [pinError, setPinError] = useState(false);
  const [otpCode, setOtpCode] = useState(Array(6).fill(""));
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [otpResent, setOtpResent] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const timerRef = useRef(null);
  const inputsRef = useRef([]);

  const location = useLocation();
  const navigate = useNavigate();
  const signupData = location.state?.signupData;
  const authType = location.state?.authType;

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    const isComplete = otpCode.every((digit) => digit !== "");
    setIsButtonDisabled(!isComplete);
  }, [otpCode]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    console.log("value", value);
    if (!/^[0-9]?$/.test(value)) return;

    const newCode = [...otpCode];
    newCode[index] = value;
    setOtpCode(newCode);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newCode = [...otpCode];
      if (otpCode[index]) {
        newCode[index] = "";
      } else if (index > 0) {
        newCode[index - 1] = "";
        inputsRef.current[index - 1]?.focus();
      }
      setOtpCode(newCode);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const joinedOtp = otpCode.join("");
    console.log("Submitclicked_SAUMYA", joinedOtp);

    // Assuming SIGNUP_URL is defined somewhere with your backend URL
    try {
      const response = await fetch(authType === "password" ? VERIFY_RESET_OTP : VERIFY_OTP, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ otp: joinedOtp, email: signupData.email }),
      });

      const data = await response.json();
      if (data?.success || data?.data.success) {
        // dispatch(addUser(data?.data));
        if (authType === "signup") navigate("/", { state: { signupData, authType } });
        if (authType === "password")
          navigate("/reset_password", { state: { signupData, authType, sessionToken: data?.data.sessionToken } });
      } else {
        // const emailError = data?.data?.email[0];
        // setEmailErrors(emailError);
        // setErrorMessage(data.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      // Handle fetch or other errors
      console.error("Error submitting form:", error);
    }

    await fakeApiCall();

    setTimeout(() => {
      clearInterval(timerRef.current);
      setTimeLeft(60);
      setPinError(true);
      setOtpCode(Array(6).fill(""));
    }, 1000);

    setIsLoading(false);
  };

  const fakeApiCall = () => {
    return new Promise((resolve) => setTimeout(resolve, 5000));
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleResendCode = () => {
    setOtpResent(true);
    setTimeLeft(60);
    setOtpCode(Array(6).fill(""));
    setPinError(false);

    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="bg-white h-screen flex flex-col">
      <Link to="/" className="w-40 p-4 cursor-pointer ">
        <img src={ZinancialLogo} alt="Zinancial Logo" />
      </Link>
      <Link to="/" className="w-40 px-4 cursor-pointer ">
        <button className="flex  bg-F4F4F4 border border-EAE2E2 rounded-lg py-2  px-5 gap-4 items-center">
          <LeftSideArrowIcon />
          <span className="text-[#535252] text-lg font-medium">BACK</span>
        </button>
      </Link>

      <div className="flex items-center justify-center h-full">
        <div className="px-5 py-8 border-[#EDEDED] border rounded mx-28 w-1/2 max-w-2xl stroke-[#EDEDED] ">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col space-y-5 px-8 text-center">
              <span className="flex justify-center">
                <AuthenticationIcon />
              </span>
              <span className="text-[#1D5D9B] text-2xl font-bold">Authenticate Your Account</span>
              <span className="text-[#545B61] text-base font-normal">
                Please enter the authentication code. The authentication code has been sent to your email:{" "}
                <span className="text-base font-medium">{signupData.email}</span>
              </span>

              <div className="flex flex-col gap-2">
                <span className="text-[#545B61] text-base font-medium">Two-factor code</span>
                <div className="flex flex-col items-center justify-center">
                  <div className="flex flex-col gap-2">
                    <div className="flex gap-2">
                      {otpCode.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          placeholder="0"
                          maxLength={1}
                          value={digit}
                          ref={(el) => (inputsRef.current[index] = el)}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className="w-10 h-11 border border-gray-300 text-center text-lg rounded"
                        />
                      ))}
                    </div>
                    <span className="flex justify-end">
                      {pinError && <span className="text-[#F16136] text-xs font-normal">Incorrect Pin</span>}
                    </span>
                  </div>
                </div>
              </div>

              <span>
                <span className="flex justify-end text-[#F16136] text-xs font-normal mb-1 mr-2">
                  {(timeLeft > 0 && formatTime(timeLeft)) || (timeLeft === 0 && "OTP Expired")}
                </span>
                <Button
                  onClick={handleSubmit}
                  type="submit"
                  size="medium"
                  isLoading={isLoading}
                  className={`bg-[#1D4469] w-full  text-white text-lg font-bold py-1 rounded-md  hover:bg-[#092239] ${
                    isLoading || isButtonDisabled ? "bg-gray-400 pointer-events-none hover:bg-gray-400" : ""
                  }`}
                  disabled={isLoading || isButtonDisabled}
                >
                  Submit
                </Button>
              </span>
            </div>

            <div className="text-center text-[#545B61] text-base font-normal space-y-5 px-16">
              It may take a minute to receive your code. Haven’t received it?
              <span
                onClick={() => {
                  handleResendCode();
                  alert("OTP Resent");
                }}
                className=" cursor-pointer text-[#F16136] text-base font-medium ml-1"
              >
                Resend a new code
              </span>
            </div>

            {/* <div className="flex items-center">
            <hr className="h-[1px] w-full bg-[#EDEDED]" />
          </div> */}

            {/* <span className="flex justify-between px-8">
            <span className="text-[#2999BC] text-base font-medium">Disable Multi-Authentication</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="25" viewBox="0 0 32 25" fill="none">
              <path
                d="M8.5212 4H23.5781C28.2311 4.0546 32 7.84616 32 12.5C32 17.1538 28.2311 20.9454 23.5781 20.9987C23.5781 21 8.5212 21 8.5212 21C3.82259 21 0 17.1869 0 12.5C0 7.81308 3.82259 4 8.5212 4ZM23.4788 19.0194C27.0826 19.0194 30.0145 16.0948 30.0145 12.5C30.0145 8.90518 27.0826 5.98058 23.4788 5.98058C19.875 5.98058 16.9431 8.90518 16.9431 12.5C16.9431 16.0948 19.875 19.0194 23.4788 19.0194Z"
                fill="#2999BC"
              />
            </svg>
          </span> */}
          </div>
        </div>
        <FooterFixed />
      </div>
    </div>
  );
};

export default AuthenticationBox;
